import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function LinkedProjectsReducer(state = initialState.linkedProjects, action) {
	switch (action.type) {
		case types.GET_LINKED_PROJECTS_BY_ENGAGEMENTID: {
			return _.cloneDeep(action.response);
		}
		case types.POST_LINKED_PROJECTS_BY_ENGAGEMENTID: {
			if (action.error) {
				return state;
			}
			return _.cloneDeep(action.response);
		}
		// TODO: remove on v2 integration
		case types.DELETE_LINKED_PROJECT_BY_ENGAGEMENTID_AND_PROJECTID: {
			return state.filter((x) => x.projectId !== action.projectId);
		}
		case types.DELETE_LINKED_PROJECT_BY_ENGAGEMENTID_AND_ENGAGEMENTHELIXID: {
			if (action.responseObj.status || action.error?.status === HttpStatusCodes.NotFound) {
				return state.filter((x) => x.engagementHelixId !== action.engagementHelixId);
			} else {
				return state;
			}
		}

		case types.UPDATE_LINKED_PROJECT_BY_ENGAGEMENTID_AND_PROJECTID: {
			// If api failed then do not do anything
			if (action.error) {
				return state;
			}

			// if we are making primary then only
			// update state, otherwise we are not updating it.
			if (action.data.isPrimary === true) {
				let newState = _.cloneDeep(state);
				let project = newState.filter((x) => x.projectId === action.data.projectId);
				if (project && project.length > 0) {
					project[0].isPrimary = true;
				}

				let projects = newState.filter((x) => x.projectId !== action.data.projectId);
				projects.map((x) => {
					x.isPrimary = false;
				});

				return newState;
			}

			return state;
		}
		default:
			return state;
	}
}
